import { createElement } from 'react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

const systemRoleCard = EntityCardBlueprint.make({
  name: 'role-card',
  params: {
    type: 'info',
    filter: entity => entity.kind === 'System',
    loader: async () => {
      const { SystemRoleCard } = await import('./components/SystemRoleCard/SystemRoleCard');
      return createElement(SystemRoleCard);
    },
  },
});

const userProfileRolesCard = EntityCardBlueprint.make({
  name: 'user-profile-roles-card',
  params: {
    type: 'info',
    filter: entity => entity.kind === 'User',
    loader: async () => {
      const { UserProfileRolesCard } = await import('./components/UserProfileRolesCard/UserProfileRolesCard');
      return createElement(UserProfileRolesCard);
    },
  },
});

export const catalogModuleRolesCard = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    systemRoleCard,
    userProfileRolesCard,
  ],
});
